import { render } from "./Cards.vue?vue&type=template&id=0b05437f"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=0b05437f&lang=scss"

import exportComponent from "E:\\Work\\Elkashef\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__